<template>
  <div style="position: relative;overflow: hidden;">
    <!-- 静安公告列表 -->
    <div ref="noticeRef" class="intract-notice" v-if="enableNotice && notices.length">
      <div class="notice-icon">
        <img src="@/assets/images/ja-notice/icon-notice.png" alt="" />
      </div>
      <div class="notice-right">
        <div class="notice_item" v-for="(item, index) in calcNotices" :key="index">
          <img src="@/assets/images/ja-notice/icon-top.png" alt="" />
          <div @click="handleNoticeDetail(item)">
            {{ item.content }}
          </div>
        </div>
        <div class="notice_handle" v-if="notices.length > 1">
          <div class="points" v-show="isNoticeCollapsed">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <template v-if="isNoticeCollapsed">
            <div @click="isNoticeCollapsed = !isNoticeCollapsed">
              <img src="@/assets/images/ja-notice/icon-arrow-down.png" alt="" /> <span class="tip-text">展开</span>
            </div>
          </template>
          <template v-else>
            <div @click="isNoticeCollapsed = !isNoticeCollapsed">
              <img src="@/assets/images/ja-notice/icon-arrow-up.png" alt="" /> <span class="tip-text">收起</span>
            </div>
          </template>
        </div>
      </div>
      <van-dialog v-model="noticeDetailVisible" className="interact-notice-dialog" :showConfirmButton="false" title="公告" getContainer="body">
        <div class="notice-content">
          <pre>
            {{ detailNotice }}
          </pre>
          <div v-if="noticeLink" style="text-align:center; padding-top:24px">
            <van-button @click="toNoticeLink" style="width: 140px; border-radius: 8px" color="#27B9F4" type="primary">点击跳转</van-button>
          </div>
        </div>
        <div class="notice-close">
          <van-icon @click="noticeDetailVisible = false" name="close" color="#fff" :size="32" />
        </div>
      </van-dialog>
    </div>
    <div :style="contentStyle" style="position: relative; overscroll-behavior: auto none" @scroll="scrollHandle">
      <div v-if="enableNotice && notices.length" :style="{ height: noticeHeight + 'px' }"></div>
      <div class="interact">
        <!-- <van-pull-refresh
          v-model="loading"
          :loading-text="finished ? '' : '加载中'"
          :success-text="finished ? '' : ''"
          @refresh="onLoadMore"
          :disabled="true"
        > -->
        <div class="interact-content">
          <div v-if="finished && !loading" style="text-align:center;color:#999;font-size: 14px">没有更多了～</div>
          <ul id="interactList">
            <li class="msg-item" v-for="(item, index) in list" :key="item.id" :id="item.id">
              <div class="interact-title">
                <van-image v-if="item.memberHeadImg" round fit="cover" class="photo" :src="item.memberHeadImg" />
                <span> {{ item.memberNickname }}</span>
                <div class="personal" v-if="item.label">{{ item.label }}</div>
                <a>{{ item.publishDate }}</a>
                <div class="more">
                  <span @click="() => menuShowMore(item, index)">...</span>
                  <div class="jubao" @click="() => showJubaoDialog(item, index)" :class="{ 'jubao-show': item.showMore }">
                    <img src="~@/assets/images/icon-safe.png" alt="" />
                    <div>举报</div>
                  </div>
                </div>
              </div>
              <!-- <div class="circle"></div> -->
              <div class="bubble">
                <!-- <h4 class="title">{{ item.text }}</h4> -->
                <LongTouch tag="h4" class="title" needCopy @copy="handleCopy(item.text)">
                  {{ item.text }}
                </LongTouch>
                <!-- <img v-if="item.imgUrl" :src="item.imgUrl" alt width="100%" max-height="400px" /> -->
                <van-grid v-if="item.imgUrlList.length <= 3 && item.imgUrlList.length !== 0" :border="false" :column-num="item.imgUrlList.length">
                  <van-grid-item v-for="value in item.imgUrlList" :key="value">
                    <van-image :src="value" />
                  </van-grid-item>
                </van-grid>
                <van-grid v-if="item.imgUrlList.length === 4" :border="false" :column-num="2">
                  <van-grid-item v-for="value in item.imgUrlList" :key="value">
                    <van-image :src="value" />
                  </van-grid-item>
                </van-grid>
                <van-grid v-if="item.imgUrlList.length > 4" :border="false" :column-num="3">
                  <van-grid-item v-for="value in item.imgUrlList" :key="value">
                    <van-image :src="value" />
                  </van-grid-item>
                </van-grid>
                <div v-if="item.videoUrlList">
                  <VideoPlayer
                    v-for="value in item.videoUrlList"
                    :key="value"
                    :options="{
                      poster: value + '?vframe/jpg/offset/0',
                      autoplay: false,
                      sources: [
                        {
                          src: value,
                          type: 'video/mp4'
                        }
                      ]
                    }"
                  />
                  <!-- <video
                  v-for="value in item.videoUrlList"
                  :key="value"
                  ref="video"
                  playsinline="true"
                  webkit-playsinline="true"
                  x-webkit-airplay="allow"
                  x5-video-player-type="h5"
                  x5-video-player-fullscreen="true"
                  x5-video-orientation="portrait"
                  id="myvideo"
                  controls
                  width="100%"
                  :poster="value + '?vframe/jpg/offset/0'"
                >
                  <source :src="value" />
                </video> -->
                </div>
              </div>
            </li>
          </ul>
          <ul id="bottom-empty"></ul>
        </div>
        <div v-if="!enableBottomOut && unreadCount > 0" class="unread-tip">
          <span @click="bottomOutHandle">底部有新消息</span>
        </div>

        <van-dialog
          v-model="jubaoVisible"
          title="请输入举报原因"
          confirmButtonText="提交"
          confirmButtonColor="#0094F7FF"
          getContainer="body"
          show-cancel-button
          :before-close="jubaoSubmit"
        >
          <van-field
            v-model="jubaoText"
            type="textarea"
            placeholder="请输入"
            autofocus
            :autosize="{ maxHeight: 100, minHeight: 100 }"
            class="interact-jubao-input"
          />
        </van-dialog>
        <!-- </van-pull-refresh> -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { isLogin, openAppAndLoginInterceptor } from '@/core';
import { throttle } from '@/utils/el';
export default {
  name: 'Interact',
  props: {
    contentStyle: Object
  },
  data() {
    return {
      moment,
      list: [],
      groupId: $$.module.data.room.chatSettingContent.chatImGroupId,
      chatList: [],
      value: {},
      firstref: '',
      pageNo: 1,
      publishDate: [],
      loading: false,
      finished: false,
      refreshing: false,
      api: $$.module.interview.$api,
      chartdata: {
        groupId: this.groupId,
        nextId: '',
        count: 3
      },
      siteId: $$.module.data.room.siteId,
      auth: $$.module.data.userinfo.auth,
      chatFlg: $$.module.data.room.chatSettingContent.chatFlg,
      liveState: $$.module.data.room.roomSettingContent.roomInfo.liveState,
      enableBottomOut: true,
      unreadCount: 0,
      lastShowMoreItem: null,
      jubaoVisible: false,
      jubaoText: null,
      jubaoTimer: null,
      first: true,
      throttleHandleEnableToBottom: throttle(this.handleEnableToBottom, 100),
      // 静安公告
      notices: [],
      isNoticeCollapsed: true,
      noticeDetailVisible: false,
      detailNotice: '',
      noticeLink: '',
      noticeHeight: 0,

      scrollTop: 0
    };
  },
  computed: {
    calcNotices() {
      if (!this.notices.length) return this.notices;
      return this.isNoticeCollapsed ? this.notices.slice(0, 1) : this.notices;
    },
    isJa() {
      return this.siteId == '310106';
    },
    enableNotice() {
      return ['310106', '310112', '100000'].includes(this.siteId);
    }
  },
  watch: {
    isNoticeCollapsed() {
      this.$nextTick(() => {
        this.calcNoticeHeight();
      });
    }
  },
  mounted() {
    console.log(this.chatFlg);
    // if (this.chatFlg == 1 && this.auth == 1) {
    // this.getList(true);
    // }
    isLogin().then(() => {
      this.isLogin = true;
    });
    this.api.getNoticeList({
      data: { roomId: $$.module.data.room.roomId },
      success: (res) => {
        this.notices = res || [];
        this.$nextTick(() => {
          this.calcNoticeHeight();
        });
      }
    });
  },
  methods: {
    handleEnableToBottom() {
      this.$nextTick(() => {
        const emptyEl = this.$el.querySelector('#bottom-empty');
        (this.enableBottomOut = this.isInViewPort(emptyEl)) && (this.unreadCount = 0);
      });
    },
    calcNoticeHeight() {
      this.noticeHeight = this.$refs.noticeRef?.getBoundingClientRect().height || 0;
    },
    handleCopy(text) {
      console.log('复制消息', text);
      rmt?.setClipboardText({
        text: text //要设置的文本
      });
      this.$toast('已复制');
    },
    handleNoticeDetail(item) {
      this.noticeDetailVisible = true;
      this.detailNotice = item.content;
      // item.type === '2' 可跳外链
      this.noticeLink = item.type === '2' ? item.linkUrl : '';
    },
    toNoticeLink() {
      this.noticeDetailVisible = false;
      window.open(this.noticeLink, '_blank');
    },
    jubaoSubmit(action, done) {
      if (action === 'confirm') {
        if (!this.jubaoText) {
          this.$toast('请输入举报原因');
          done(false);
        } else {
          this.$toast('提交举报信息成功');
          done(true);
        }
      } else if (action === 'cancel') {
        done(true);
      }
    },
    menuShowMore(item, index) {
      this.jubaoText = null;
      console.log('menuShowMore');
      if (this.lastShowMoreItem && this.lastShowMoreItem.id !== item.id) {
        this.lastShowMoreItem.showMore = false;
      }
      item.showMore = !item.showMore;
      this.$set(this.list, index, item);
      if (item.showMore) {
        this.lastShowMoreItem = item;
        if (this.jubaoTimer) {
          clearTimeout(this.jubaoTimer);
          this.jubaoTimer = null;
        }
        this.jubaoTimer = setTimeout(() => {
          item.showMore = false;
          this.$set(this.list, index, item);
        }, 2000);
      }
    },
    showJubaoDialog(item, index) {
      openAppAndLoginInterceptor(
        () => {
          this.jubaoVisible = true;
          console.log('showJubaoDialog');
          item.showMore = false;
          this.$set(this.list, index, item);
        },
        { loginAfterReload: false }
      );
    },
    // im事实消息
    getMessage(value) {
      if (!value || !value.length) return;
      let count = 0;
      let hasUseMsg = false;
      value.forEach((item) => {
        // 系统消息
        if (item.from === '@TIM#SYSTEM') {
          //
          if (item.payload && item.payload.userDefinedField) {
            try {
              console.log('item.payload');
              this.notices = JSON.parse(item.payload.userDefinedField);
            } catch (error) {
              //
              console.error('parse notice error');
            }
          }
        } else {
          if (!item.payload || !item.payload.text) return;
          const obj = Object.assign({ showMore: false }, JSON.parse(item.payload.text), {
            memberNickname: item.nick,
            createDate: moment(item.time).format('YYYY-MM-DD HH:mm:ss'),
            memberHeadImg: item.avatar
          });
          console.log('msg obj', obj);
          this.list.push(obj);
          count++;
          hasUseMsg = true;
        }
      });
      // 有用户消息才出发滚动
      hasUseMsg && this.enableBottomOut ? this.bottomOutHandle() : (this.unreadCount = count);
    },

    isInViewPort(element) {
      if (!element || !element.getBoundingClientRect) return;

      const viewWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      const { top, right, bottom, left } = element.getBoundingClientRect();

      return top >= 0 && left >= 0 && right <= viewWidth + 1 && bottom <= viewHeight + 1;
    },
    scrollHandle(e) {
      this.scrollTop = e.target.scrollTop;
      this.checkScrollTopLoad();
      this.throttleHandleEnableToBottom();
    },

    checkScrollTopLoad() {
      console.log('this.scrollTop', this.scrollTop);
      if (this.scrollTop === 0 && !this.loading && !this.finished) {
        this.getList();
      }
    },

    bottomOutHandle() {
      this.$nextTick(() => {
        const emptyEl = this.$el.querySelector('#bottom-empty');
        if (!this.isInViewPort(emptyEl)) {
          emptyEl.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          });
          this.enableBottomOut = true;
          this.unreadCount = 0;
        }
      });
    },
    // 历史消息
    getList() {
      if (this.loading) return;
      this.loading = true;
      // 修正获取历史消息的pageNo和pageSize
      const baseSize = 30;
      const msgLen = this.list.length;
      let fixSize = msgLen % baseSize;
      this.pageNo = parseInt(msgLen / baseSize + 1);
      this.api.member({
        data: {
          roomId: $$.module.data.room.roomId,
          pageNo: this.pageNo,
          pageSize: baseSize + fixSize
        },
        success: (data) => {
          this.value = data;
          if (this.first) {
            this.$emit('getList', this.value);
          }
          if (!data.records || !data.records.length) {
            this.finished = true;
          }
          data.records.forEach((item) => {
            if (this.list.length) {
              // 去重
              const has = this.list.findIndex((v) => v.id === item.id);
              if (has !== -1) {
                item.isDel = true;
                return;
              }
            }
            item.showMore = false;
            if (item && item.publishDate) {
              item.publishDate = this.showTimePipe(item.publishDate);
            }
          });
          data.records = data.records.filter((v) => !v.isDel);
          if (data.records && data.records.length) {
            this.list = data.records.reverse().concat(this.list);
            if (this.first) {
              this.$nextTick(() => {
                document.getElementById(data.records[data.records.length - 1].id).scrollIntoView({
                  behavior: 'auto',
                  block: 'start'
                });
              });
            } else {
              this.$nextTick(() => {
                document.getElementById(data.records[data.records.length - 1].id).scrollIntoView({
                  behavior: 'auto',
                  block: 'start'
                });
                // setTimeout(() => {
                //   this.checkScrollTopLoad();
                // }, 0);
              });
            }
          }

          this.first = false;
          this.loading = false;
        }
      });
    },
    showTimePipe(unix_stamp) {
      if (!unix_stamp) {
        return '';
      }
      unix_stamp = Date.parse(unix_stamp.replace(/-/g, '/'));
      if (!unix_stamp) {
        return '';
      }
      // unix_stamp 精确到微秒
      var _today_obj = new Date(),
        _today_date = {
          y: _today_obj.getFullYear(),
          m: _today_obj.getMonth() + 1 < 10 ? '0' + (_today_obj.getMonth() - -1) : _today_obj.getMonth() - -1,
          d: _today_obj.getDate() < 10 ? '0' + _today_obj.getDate() : _today_obj.getDate()
        };
      var _today_stamp = Date.parse(_today_date.y + '/' + _today_date.m + '/' + _today_date.d + ' 00:00:00');
      var stamp = [];
      stamp[0] = _today_stamp + 86400000;
      stamp[1] = _today_stamp;
      stamp[2] = _today_stamp - 86400000;
      stamp[3] = _today_stamp - 172800000;

      stamp[4] = _today_stamp - 518400000; // 7天

      stamp[5] = _today_stamp - 31536000000; // 365天

      var _compare_obj = new Date();
      _compare_obj.setTime(unix_stamp);

      var return_str;

      if (unix_stamp >= stamp[1] && unix_stamp < stamp[0]) {
        return_str = _compare_obj.getHours() + ':' + (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[2] && unix_stamp < stamp[1]) {
        var yesterdayText = '昨天';
        return_str =
          yesterdayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
        console.log(return_str, 'return_str昨');
      } else if (unix_stamp >= stamp[3] && unix_stamp < stamp[2]) {
        var theDayBeforeYesterdayText = '前天';
        return_str =
          theDayBeforeYesterdayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[4] && unix_stamp < stamp[3]) {
        // 7天内
        var daynames = ['天', '一', '二', '三', '四', '五', '六'];
        var dathStr = '星期' + daynames[_compare_obj.getDay()];

        var SundayText = '星期天';
        var MondayText = '星期一';
        var TuesdayText = '星期二';
        var WednesdayText = '星期三';
        var ThursdayText = '星期四';
        var FridayText = '星期五';
        var SaturdayText = '星期六';

        var dathStr2;

        switch (dathStr) {
          case '星期天':
            dathStr2 = SundayText;
            break;
          case '星期一':
            dathStr2 = MondayText;
            break;
          case '星期二':
            dathStr2 = TuesdayText;
            break;
          case '星期三':
            dathStr2 = WednesdayText;
            break;
          case '星期四':
            dathStr2 = ThursdayText;
            break;
          case '星期五':
            dathStr2 = FridayText;
            break;
          case '星期六':
            dathStr2 = SaturdayText;
            break;
          default:
            dathStr2 = dathStr;
            break;
        }

        return_str =
          dathStr2 +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[5] && unix_stamp < stamp[4]) {
        // 365天内
        var monthText = '月';
        var dayText = '日';
        return_str =
          _compare_obj.getMonth() -
          -1 +
          monthText +
          _compare_obj.getDate() +
          dayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      } else {
        var yearText = '年';
        let monthText = '月';
        let dayText = '日';
        return_str =
          _compare_obj.getFullYear() +
          yearText +
          (_compare_obj.getMonth() - -1) +
          monthText +
          _compare_obj.getDate() +
          dayText +
          ' ' +
          _compare_obj.getHours() +
          ':' +
          (_compare_obj.getMinutes() < 10 ? '0' + _compare_obj.getMinutes() : _compare_obj.getMinutes());
      }
      return return_str;
      // resolve(return_str);
      // });
    },

    view() {
      this.getList();
    },
    onRefresh() {
      // 清空列表数据
      this.list = [];
      this.pageNo = 1;
      this.refreshing = false;
      this.finished = false;
      this.loading = false;
      this.first = true;
      this.getList();
    },
    onLoadMore() {
      this.view();
    }
  }
};
</script>
